import { CSSObject } from '@mantine/core'
import { MantineThemeComponents } from '@mantine/styles/lib/theme/types/MantineTheme'
import { getActionIconStyles } from 'plugin-mantine-resources/src/helpers/actionIconHelpers'

export const ActionIcon: MantineThemeComponents['ActionIcon'] = {
    styles: (__, _, runtimeProps): Record<string, CSSObject> => {
        return getActionIconStyles(runtimeProps)
    }
}
